import { Table } from 'antd';
import React, { Component } from 'react';

const WITHDRAW_STATUS = {
  WITHDRAW_AUDIT: '审核中',
  WITHDRAW_PROCESS: '提现中',
  WITHDRAW_FINISH: '提现完成',
  WITHDRAW_FAILED: '提现失败'
}

const columns = [{
  title: '提现编号',
  dataIndex: 'orderId',
  key: 'orderId',
}, {
  title: '提现金额（元）',
  dataIndex: 'totalFee',
  key: 'totalFee',
  render: text => Math.abs(text)
}, {
  title: '申请提现时间',
  dataIndex: 'ctime',
  key: 'ctime',
}, {
  title: '提现状态',
  key: 'status',
  dataIndex: 'status',
  render: text => WITHDRAW_STATUS[text],
}];

class WithdrawTable extends Component {
    render() {
      const { withdrawList, total } = this.props;

      return (
          <Table 
            columns={columns} 
            dataSource={withdrawList}
            onChange={this.props.onChange}
            pagination={{
              pageSize: 10,
              total
            }}
          />
      );
    }
}
export default WithdrawTable;